import { Dispatch, SetStateAction, useMemo } from 'react';

import { Box, Button, Typography } from '@mui/material';
import { Formik } from 'formik';
import * as Yup from 'yup';

import { CissTextField } from 'components/fields';
import { ContentModal } from 'components/modal';
import { useDreConfigContext } from 'pages/financeiro/dre/configuracao/contexts/DreConfigContext';
import { useMutateSubgrupo } from 'pages/financeiro/dre/configuracao/hooks';
import { DreSubgrupo } from 'pages/financeiro/dre/configuracao/types';

type DreSubgruposModal = {
    subgrupo?: DreSubgrupo;
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
};

export function DreConfigSubgruposModal({ subgrupo, open, setOpen }: DreSubgruposModal) {
    const { activeGrupo, subgrupos } = useDreConfigContext();
    const { isLoading, onSubmitForm } = useMutateSubgrupo({ setOpen });

    const validationNewGrade = Yup.object({
        dsDreMercadologicaGrupoExibicao: Yup.string().required(),
        dsNomeVariavel: Yup.string().required(),
    });

    /**
     * Retorna o próximo número de sequência disponível para o subgrupo.
     */
    const nextNrSequencia = useMemo(() => (subgrupos.at(-1)?.nrSequencia || 0) + 1, [subgrupos]);

    return (
        <ContentModal
            open={open}
            setOpen={setOpen}
            sx={{
                display: 'flex',
                maxHeight: '90vh',
                flexDirection: 'column',
                borderRadius: 1,
                gap: 2,
                padding: 2,
                width: { xs: '90vw', sm: 500 },
            }}
        >
            <Typography sx={{ color: 'secondary.main', fontSize: '18px' }}>{subgrupo ? 'Editar subgrupo' : 'Adicionar subgrupo'}</Typography>

            <Formik
                validateOnChange={false}
                onSubmit={onSubmitForm}
                validationSchema={validationNewGrade}
                initialValues={
                    subgrupo ||
                    ({
                        dsNomeVariavel: '',
                        dsDreMercadologicaGrupoExibicao: '',
                        tipoDreMercadologicaGrupoExibicao: activeGrupo,
                        fgAtivo: true,
                        nrSequencia: nextNrSequencia,
                    } as DreSubgrupo)
                }
            >
                {({ values, errors, setFieldValue, submitForm }) => (
                    <>
                        <CissTextField
                            size="small"
                            label="Descrição"
                            value={values.dsDreMercadologicaGrupoExibicao}
                            error={errors.dsDreMercadologicaGrupoExibicao}
                            onChange={(e) => setFieldValue('dsDreMercadologicaGrupoExibicao', e.target.value)}
                        />

                        <CissTextField
                            size="small"
                            label="Nome da variável"
                            value={values.dsNomeVariavel}
                            error={errors.dsNomeVariavel}
                            onChange={(e) => setFieldValue('dsNomeVariavel', e.target.value)}
                        />

                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                            <Button size="small" variant="outlined" onClick={() => setOpen(false)}>
                                Fechar
                            </Button>

                            <Button variant="contained" size="small" onClick={submitForm} loading={isLoading}>
                                Salvar
                            </Button>
                        </Box>
                    </>
                )}
            </Formik>
        </ContentModal>
    );
}
